import React, {FC} from 'react';
import {connect} from "react-redux";
import MixPage from "../../components/Main/MixPage";
import {updatePreferencesMix} from "../../modules/SelectionPreferences";
import {IMix} from "../../constants/types";

interface IMixPreferencesPage {
    mix: IMix,
    updatePreferencesMix: any
}

const MixPreferencesPage: FC<IMixPreferencesPage> = ({
                                                         mix,
                                                         updatePreferencesMix}) => {
    return (
        <MixPage
            mix={mix}
            handleLikeButton={updatePreferencesMix}
        />
    )
};

const mapStateToProps = (state: any) => ({
    mix: state.selectionPreferences.currentMix
});

const mapDispatchToProps = (dispatch: any) => ({
    updatePreferencesMix: (id: number, isMixLiked: boolean) => dispatch(updatePreferencesMix(id, isMixLiked)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MixPreferencesPage)

